var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeCaixaG(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4029_9534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8574 61.8164H34.352L45.1729 47.3877C43.8384 46.6641 42.5669 45.9067 41.3657 45.1392L28.8574 61.8164Z",
    fill: "#2544B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7373 42.6533C37.5337 42.5039 34.5703 40.2832 34.5703 40.2832C34.1895 39.9976 33.728 39.8438 33.252 39.8438H28.8574C25.2231 39.8438 22.2656 42.8013 22.2656 46.4355C22.2656 47.647 21.2798 48.6328 20.0684 48.6328H13.1001C12.1934 46.0752 9.75 44.2383 6.88477 44.2383H2.19727C0.984375 44.2383 0 45.2227 0 46.4355V61.8164H23.3643L37.7373 42.6533Z",
    fill: "#2544B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8716 61.7651L74.0264 57.1348C72.6673 54.6527 69.9458 52.9112 66.7666 53.0332C66.3359 53.0508 65.9082 53.0581 65.4819 53.0581C62.9214 53.0581 60.4209 52.7651 58.0068 52.2524L53.4453 51.0088C51.9819 50.5225 50.5596 49.9673 49.187 49.3608L39.8457 61.8164H45.3389L50.8716 61.7651Z",
    fill: "#2544B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8301 66.2109C48.1932 66.2109 2.70015 66.2109 0 66.2109V72.8027C0 74.0156 0.984375 75 2.19727 75H46.8384C55.6348 75 64.1528 72.4204 71.4727 67.541C73.5498 66.1567 74.8389 63.8965 74.9868 61.4224C49.9825 66.4088 51.2448 66.2109 50.8301 66.2109Z",
    fill: "#2544B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1431 21.9727L33.6348 5.29541C32.4336 6.06445 31.1606 6.82031 29.8262 7.54395L40.6484 21.9727H46.1431Z",
    fill: "#2544B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6621 21.9727H35.1553L25.814 9.51709C24.4414 10.1235 23.0205 10.6802 21.5557 11.1665L16.9941 12.4087C14.5801 12.9214 12.0796 13.2144 9.51904 13.2144C9.09277 13.2144 8.66504 13.2056 8.23437 13.1895C5.07661 13.0682 2.35332 14.7869 0.974609 17.2895L24.1294 21.9214L29.6621 21.9727Z",
    fill: "#2544B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8027 4.39453H68.1152C65.25 4.39453 62.8066 6.23145 61.8999 8.78906H54.9316C53.7202 8.78906 52.7344 7.80322 52.7344 6.5918C52.7344 2.95752 49.7769 0 46.1426 0H41.748C41.272 0 40.8105 0.153809 40.4297 0.439453C40.4297 0.439453 37.4663 2.66016 37.2627 2.80957L51.6357 21.9727H75V6.5918C75 5.37891 74.0156 4.39453 72.8027 4.39453Z",
    fill: "#2544B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0136719 21.5801C0.161621 24.0527 1.45068 26.313 3.52783 27.6973C10.8477 32.5767 19.3657 35.1562 28.1621 35.1562H72.8032C74.0161 35.1562 75.0005 34.1719 75.0005 32.959V26.3672C72.3003 26.3672 24.1704 26.3672 24.1704 26.3672C24.1704 26.3672 25.1706 26.5956 0.0136719 21.5801Z",
    fill: "#2544B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4029_9534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeCaixaG);
export default __webpack_public_path__ + "static/media/icone-caixa-g.9231acded9f05c303324b02be8bde644.svg";
export { ForwardRef as ReactComponent };